import { countUnread, getUnreadMessages } from "../services/conversations";

export const countUnreadConversations = () => async (dispatch) => {
  try {
    const res = await countUnread();
    if (!res.success) {
      return false;
    }

    dispatch({
      type: "SET_UNREAD_CONVERSATIONS",
      payload: res.data,
    });
  } catch(error) {
    console.error("[ERROR] at ACTIONS - countUnreadConversations", error);
  }
};

export const countUnreadMessages = () => async (dispatch) => {
  try {
    const res = await getUnreadMessages();
    if (!res.success) {
      return false;
    }

    dispatch({
      type: "SET_UNREAD_MESSAGES",
      payload: res.data,
    });
  } catch(error) {
    console.error("[ERROR] at ACTIONS - countUnreadMessages", error);
  }
};

export const setConversations = (conversations) => ({
  type: "SET_CONVERSATIONS",
  payload: conversations,
});

export const setConversationDetails = (details) => ({
  type: "SET_CONVERSATION_DETAILS",
  payload: details,
});

export const setConversationMessages = (details) => ({
  type: "SET_MESSAGES",
  payload: details,
});

export const setComposeConversation = (conversation) => ({
  type: "SET_COMPOSE_CONVERSATION",
  payload: conversation,
});

export const setComposeSidebar = (open) => ({
  type: "SET_COMPOSE_SIDEBAR",
  payload: open,
});

export const setEditSidebar = (open) => ({
  type: "SET_EDIT_SIDEBAR",
  payload: open,
});

export const setSidebar = (open) => ({
  type: "SET_SIDEBAR",
  payload: open,
});
